import React, { createContext, useContext, useEffect } from "react";
import defaultAvatar from "../assets/img/profile/default.png";
import profileBanner from "../assets/img/profile/banner.png";
import defaultLogo from "../assets/img/account/placeholder.png";

import error from "../assets/img/others/error.png";

import { convertToDataURI } from "util/conversions";

class ImageContextType {
  defaultAvatar: string | ArrayBuffer;
  profileBanner: string | ArrayBuffer;
  defaultLogo: string | ArrayBuffer;
  error: string | ArrayBuffer;
}

const DefaultImageContext = createContext<ImageContextType | undefined>(
  undefined
);

const DefaultImageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  //#region : State management

  const [imageUris, setImageUris] = React.useState<ImageContextType>();

  useEffect(() => {
    (async () => {
      // Initialize image context
      const imageUris = new ImageContextType();

      // Convert images to data URIs
      imageUris.defaultAvatar = defaultAvatar;
      imageUris.defaultLogo = defaultLogo;
      imageUris.profileBanner = profileBanner;
      imageUris.error = error;
      setImageUris(imageUris);
    })();
  }, []);

  //#endregion

  return (
    <DefaultImageContext.Provider value={imageUris}>
      {children}
    </DefaultImageContext.Provider>
  );
};

const useDefaultImages = (): ImageContextType => {
  const context = useContext(DefaultImageContext);

  // Ensure the context is defined
  if (!context) {
    throw new Error("useImages must be used within an ImageProvider");
  }
  return context;
};

export { DefaultImageProvider, useDefaultImages };
